/* eslint-disable  */
import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import { BiArrowFromBottom, BiArrowFromTop } from 'react-icons/bi';

import { connectWebSocket } from '../../lib/cmra-data-collection';

import Blocks from '../../containers/blocks.jsx';
import UnityPane from '../../containers/unity-pane.jsx';
import styles from './p3g_gui.css';


export const P3G = ({layout, canUseCloud, blocksTabVisible, basePath, vm, stageSizeMode }) => {
  const [hideBlockly, setHideBlockly] = useState(true);
  
  useEffect(() => {
    connectWebSocket();
  }, [vm]); // Based off of the VM because I think we would want to reconnect when the vm changes for another play session.


  const openPI = () => {
    const outgoing = {
      topic: 'settings',
      message: {
          method: 'open_PI'
      }
  };
    const message = JSON.stringify(outgoing);
 
    vm.runtime.unity.send('UnityMessenger', 'UnityMessengerDispatcher', message);
    setHideBlockly(false);
  }
  const closePI = () => {
    const outgoing = {
      topic: 'settings',
      message: {
          method: 'close_PI'
      }
  };
    const message = JSON.stringify(outgoing);
 
    vm.runtime.unity.send('UnityMessenger', 'UnityMessengerDispatcher', message);
    setHideBlockly(true);
  }

  const hide = {
    overflow: 'hidden',
    display: 'none'
  }

  const show = {
    overflow: 'hidden',
    display: 'initial'
  }

  return (
    <div>
      <div className={styles.draggable_bounds}>
        <Draggable
          axis="both"
          handle=".handle"
          defaultPosition={{ x: 800, y: 100 }}
          position={null}
          grid={[50, 50]}
          scale={1}
          cancel=".unity-container"
          bounds={'parent'}
        >
          <div className={ hideBlockly ? styles.draggable_window_fullscreen : styles.draggable_window_window }>
            { hideBlockly ? 
              null :
              <div className={`handle ${styles.draggable_handle}`}>
                Drag Me
              </div>
            }
            <UnityPane width='100%' height='100%' openPI={openPI} disableCS2N={true}/>
          </div>
        </Draggable>
            
      </div>
      <div>
        { hideBlockly ? 
          <a className={styles.blockly_button} onClick={openPI}>
            <span className={styles.blockly_button_icon}>
              <BiArrowFromBottom/>
            </span>
          </a> :
          <a className={styles.blockly_button} onClick={closePI}>
            <span className={styles.blockly_button_icon}>
              <BiArrowFromTop/>
            </span>
          </a>
        }
        {!hideBlockly &&
          <Blocks
            canUseCloud={canUseCloud}
            grow={1}
            isVisible={blocksTabVisible}
            options={{
              media: `${basePath}static/blocks-media/`
            }}
            stageSize={stageSizeMode}
            vm={vm}
            position="absolute"
            layout={layout}
          />}


      </div>

    </div>
         
  )
}